import { InformationIcon, SectionHeader } from "~/common/components";

export const FillmTitle = ({ onClick }: { onClick: () => void }) => (
  <div className="flex items-center gap-2">
    <SectionHeader>Fillm</SectionHeader>
    <button onClick={onClick}>
      <InformationIcon className="size-4 text-gray-20" />
    </button>
  </div>
);
